import type { DashboardWidgetConfiguration } from './widget-definition';
import { period } from './query-period';

export const storageDetailsWidget: DashboardWidgetConfiguration = {
  widgetId: "storage.details",
  name: "Storage details",
  description: "Storage details as a compact RQL list.",
  apps: [
    "configuration",
  ],
  template: "list",
  query: {
    kind: "single",
    query: {
      version: 1,
      source: "inventory.storage-locations",
      ...period(1),
      select: [
        {
          type: "field",
          field: "name",
          as: "name",
        },
        {
          type: "field",
          field: "location_type",
          as: "location_type",
        },
        {
          type: "field",
          field: "active",
          as: "active",
        },
      ],
      limit: 1,
    },
  },
  inputs: {
    title: "Storage details",
    columns: [
      {
        key: "name",
        label: "Storage location",
      },
      {
        key: "location_type",
        label: "Type",
      },
      {
        key: "active",
        label: "Active",
      },
    ],
    maxRows: 8,
    showAccountTypeDescription: false,
  },
  dummyData: {
    rows: [],
  },
  limits: {
    minWidth: 3,
    maxWidth: 12,
    minHeight: 3,
    maxHeight: 8,
    defaultWidth: 6,
    defaultHeight: 4,
  },
};
